import { ReactComponent as FeedbackIcon } from '@assets/icons/V4/session-details/feedback-icon.svg';
import SessionDetailsEmptyState from './components/SessionDetailsEmptyState';
import SessionDetailsFeedbackLabelValue from './components/SessionDetailsFeedbackLabelValue';
import SessionDetailsLayoutCard from './components/SessionDetailsLayoutCard';
import { ParentFeedback } from '@shared/common';

type Props = {
  parentFeedback?: ParentFeedback | null;
  accentColor: string;
  isLoading?: boolean;
};

const ParentFeedbackCard = ({ parentFeedback, accentColor, isLoading = false }: Props) => {
  const hasFeedback =
    parentFeedback !== null &&
    parentFeedback !== undefined &&
    (parentFeedback.message || parentFeedback.rating !== undefined);

  return (
    <SessionDetailsLayoutCard
      isLoading={isLoading}
      title="Parent Feedback"
      icon={<FeedbackIcon className="text-white" />}
    >
      {hasFeedback ? (
        <div className="flex flex-col gap-6">
          {parentFeedback?.rating !== undefined && (
            <SessionDetailsFeedbackLabelValue
              label="Rating"
              starRating={parentFeedback.rating}
              ratingPosition="below"
            />
          )}
          {parentFeedback?.message && (
            <SessionDetailsFeedbackLabelValue label="Feedback" value={parentFeedback.message} />
          )}
        </div>
      ) : (
        <SessionDetailsEmptyState
          icon={<FeedbackIcon className="text-customGrey" />}
          text="No parent feedback yet."
        />
      )}
    </SessionDetailsLayoutCard>
  );
};

export default ParentFeedbackCard;
